export default {
  companyFeedbacksMetadata: {
    deleteFeedbackTitle: 'Delete the survey?',
    newFeedback: 'New feedback',
    name: 'Title',
    methodology: 'Select a methodology',
    sendDates: 'Send dates',
    repeatPeriod: 'Repeat period',
    chunkCount: 'The number of chunks the survey will be divided into',
    appoint: 'Feedback collection will be launched for all employees of the selected departments',
    start: 'Start the feedback',
    stop: 'Stop the feedback',
    tooltips: {
      chunkCount:
        'The number of questions in the survey will be divided into equal parts, which will be sent within one cycle. If the number of questions cannot be divided into an equal number, then the remainder of the questions will be displayed in the final part of the survey.',
      start: 'At start, parts of the surveys will be sent on the selected days of the week',
      answered: 'The number of users who evaluated this user within one cycle',
      assigned: 'The number of users who have been assigned a assessment for this user',
      importMethodology: 'Upload a json file to add the methodology to the company',
      addQuestions: 'Enter the name of the methodology and click “Save“ to add questions',
    },
    validatorsMinValue: 'The repeat period of questions cannot be less than {minLimit} days',
    confirmChangeActivity: {
      start: {
        title: 'Start the survey?',
        button: 'Yes, start',
      },
      stop: {
        title: 'Stop the survey?',
        button: 'Yes, stop',
      },
    },
    successMessages: {
      createFeedback: 'Feedback successfully created',
      changeFeedback: 'The feedback successfully changed',
      copyMethodology: 'The methodology successfully copied',
      importMethodology: 'The methodology successfully uploaded',
      deleteMethodology: 'The methodology successfully deleted',
      createMethodology: 'The methodology successfully created',
      changeMethodology: 'The methodology successfully changed',
      copyEntity: 'Survey successfully copied',
      deleteEntity: 'Survey successfully deleted',
    },
    errorMessages: {
      createFeedback: 'Failed to create feedback',
      changeFeedback: 'Failed to change the feedback',
      getFeedback: 'Failed to get data about the feedback',
      copyMethodology: 'Failed to copy the methodology',
      exportMethodology: 'Failed to generate file',
      importMethodology: 'Failed to import the methodology',
      deleteMethodology: 'Failed to delete the methodology',
      createMethodology: 'Failed to create a methodology',
      changeMethodology: 'Failed to change the methodology',
      copyEntity: 'Failed to copy the survey',
      deleteEntity: 'Failed to delete the survey',
    },
    evaluated: 'Evaluated',
    cycle: 'Cycle',
    answered: 'Number of answered',
    assigned: 'Number of assigned',
    errorGetData: 'Failed to get data for statistics',
    createMethodologyButton: 'Create a methodology',
    importMethodologyButton: 'Upload a methodology',
    onChangeMethodologyButton: 'Edit the methodology',
    deleteMethodologyButton: 'Delete the methodology',
    viewMethodologyButton: 'Viewing the methodology',
    title: 'Title',
    numOfQuestions: 'Number of questions',
    description: 'Description',
    creationDate: 'Creation date',
    copyMethodology: 'Copy the methodology',
    copyMethodologyTo: 'Copy into other company',
    exportMethodology: 'Export the methodology',
    deleteMethodologyTitle: 'Delete the methodology?',
    deleteMethodologyText:
      'Several feedbacks have been created based on this methodology. If the methodology is deleted, the feedbacks will remain active, but this methodology cannot be used to create new feedbacks.',
    questionIndex: 'Question {index}',
    SCALE: 'Scale',
    DATE: 'Date',
    NUMBER: 'Number',
    TEXT: 'Short text',
    TEXTAREA: 'Long text',
    FILE: 'File',
    PHONE: 'Phone',
    TIME: 'Time',
    SINGLE_CHOICE: 'Single choice',
    MULTI_CHOICE: 'Multiple choice',
    BOOLEAN: 'Yes or no',
    dialogTitleCopy: 'Copy into other company',
    dialogSubTitle: 'Select company or companies for copy the methodology into them',
    searchByName: 'Search by company name',
    createMethodologyTitle: 'New methodology',
    editMethodologyTitle: 'Edit the methodology',
    common: 'Common methodology for all companies',
    dialogTitle: 'Viewing the methodology',
    feedback: 'Select feedback to see the result',
    team: 'Team',
    guest: 'Guest',
    anonymous: 'Anonymous',
    evaluatedUser: 'Evaluated',
    question: 'Question',
    placeholders: {
      evaluated: 'Select the evaluated participant',
      feedback: 'This user does not participate in the selected feedback',
      noData: 'The survey was stopped forcibly, there is no data to analyze the results',
      assessment:
        'Surveys and passing results will be displayed here. To start the assessment, click the «Create survey» button.',
    },
    report: 'Summary',
    details: 'By individual users',
    summaryOfQuestions: 'Summary of questions',
    emplStatistic: 'Employees passed the survey',
    allQuestions: 'All',
    surveyDone: 'Survey is done',
    managingMethodologies: 'Managing methodologies',
    commonMethodology: 'The common methodology',
    listOfQuestions: 'List of questions',
    buttons: {
      createFeedback: 'Create a new feedback',
      changeFeedback: 'Change the feedback',
    },
    tableHeaders: {
      name: 'Name',
      status: 'Status',
      lastStart: 'Cycle start',
      nextStart: 'Start of the next cycle',
      count: 'Statistic',
      cycle: 'Cycle',
    },
    started: 'Started',
    stopped: 'Stopped',
    copyEntity: 'Copy the feedback',
    deleteEntity: 'Delete the feedback',
    startSurvey:
      'At start, the survey parts will be sent on the selected days of the week. If the survey was stopped earlier, then a new sending cycle will begin, i.e. the polls will start coming again. Scheduled submissions of survey parts from the previous cycle will be canceled.',
    stopSurvey:
      'Sending parts of surveys from this cycle will continue until the survey is completed in full, but a new survey cycle will not be started.',
  },
};
